import { config } from '@js/state';
import {
  enablePointerEvents,
  disablePointerEvents,
} from '@utils/pointer-events-control';

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({ key: 'StartScene' });
  }

  preload() {}

  create() {
    enablePointerEvents();

    this.add.image(config.width / 2, config.height / 2, 'startBackground');

    this.anims.create({
      key: 'jiggiWave',
      frames: this.anims.generateFrameNames('JiggiWaveAnim', {
        start: 0,
        end: 58,
        zeroPad: 0,
        prefix: 'jiggiwave',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
      yoyo: true,
      repeatDelay: 1000,
    });

    this.jiggi = this.add
      .sprite(0, 0, 'JiggiWaveAnim')
      .setOrigin(0)
      .setVisible(true)
      .play('jiggiWave');

    this.add.sprite(559, 445, 'startPodium').setOrigin(0);

    this.playButton = this.add
      .image(536, 592, 'playButton')
      .setOrigin(0)
      .setInteractive({ cursor: 'pointer' });

    this.playButton.on('pointerover', () => {
      this.playButton.setTexture('hover_playButton');
    });
    this.playButton.on('pointerout', () => {
      this.playButton.setTexture('playButton');
    });
    this.playButton.on('pointerup', () => {
      disablePointerEvents();

      this.scene.stop('StartScene');

      this.scene.start('TutorialScene');
      this.scene.start('UiScene');
    });
  }

  update() {}
}
